import * as TooltipPrimitive from '@radix-ui/react-tooltip';
import TooltipContent from './TooltipContent';
import TooltipProvider from './TooltipProvider';
import TooltipTrigger from './TooltipTrigger';

const Tooltip = props => (
    <TooltipProvider>
        <TooltipPrimitive.Root data-slot='tooltip' {...props} />
    </TooltipProvider>
);

Tooltip.Provider = TooltipProvider;
Tooltip.Trigger = TooltipTrigger;
Tooltip.Content = TooltipContent;

export default Tooltip;
